import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { List, Row, Cell } from '../../../components/List';
import { selectUsers } from '../selectors';
import { fetchUsersList } from '../actions';
import { VBox } from '../../../components/Box';
import { FormField } from '../../../components/FormFields';
import { DecoratorLabel, Input, RightDecoration } from '../../../components/Input';
import { Button } from '../../../components/Buttons';
import { parseUser } from '../helpers';

const Container = styled.div`
  max-height: 60vh;
  overflow-y: auto;
  width: 100%;
  .form-controlField,
  .form-controlField > div {
    width: 100%;
  }
`;

const STATE = {
  string: null,
  result: null,
};

/* eslint-disable react/prefer-stateless-function */
class UserSelectionComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  get filterCompanyId() {
    return this.props.filter?.companyId;
  }

  componentDidMount() {
    if (this.filterCompanyId) {
      this.search();
    }
  }

  onStringChange(evt) {
    let string = evt.target.value;
    this.setState({ string });
    this._t = !this.props.withoutCompany && this.timeout(this.search.bind(this), 300, this._t);
  }

  search() {
    const search = this.props.withoutCompany ? this.state.string?.toLowerCase() : this.state.string;
    this.props.fetchUsers(0, undefined, search, this.filterCompanyId, result =>
      this.setState({
        result: result.items?.map(parseUser).filter(user => user.id !== this.props.user?.id),
      }),
    );
  }

  render() {
    return (
      <Container>
        <VBox>
          <FormField>
            <Input
              name="string"
              onChange={this.onStringChange.bind(this)}
              value={this.props.value || this.state.string || ''}
              placeholder={this.lblStr('user.selection.placeholder')}
              rightDecoration={
                this.props.withoutCompany && (
                  <DecoratorLabel>
                    <Button small onClick={this.search.bind(this)}>
                      {this.lbl('search ')}
                    </Button>
                  </DecoratorLabel>
                )
              }
            />
          </FormField>
          {this.renderResult()}
        </VBox>
      </Container>
    );
  }

  renderResult() {
    if (!this.state.result) return '';

    if (this.props.withoutCompany) {
      return (
        <div className="results">
          <List>
            {this.state.result.map(user => (
              <Row
                key={user.id}
                onClick={() => {
                  this.props.onSelect?.(user);
                  this.setState({
                    result: '',
                    string: `${user?.name ?? ''} ${user?.surname ?? ''} ${user?.email_address ?? ''}`,
                  });
                }}
              >
                <Cell>
                  {user.name} {user.surname} {user.email_address}
                </Cell>
              </Row>
            ))}
          </List>
        </div>
      );
    }
    return (
      <div className="results">
        <List>
          <Row >
            <Cell>{'E-mail'}</Cell>
            <Cell>{'Name'}</Cell>
            <Cell>{'Surname'}</Cell>
          </Row>
          {this.state.result.map(user => (
            <Row key={user.id} onClick={() => this.props.onSelect?.(user)}>
              <Cell>
                {user.email_address} 
              </Cell>
              <Cell>
                {user.name} 
              </Cell>
              <Cell>
                {user.surname}
              </Cell>
            </Row>
          ))}
        </List>
      </div>
    );
  }
}

UserSelectionComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    users: selectUsers(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchUsers: (offset, limit, string, companyId, callback) => {
      dispatch(fetchUsersList(offset, limit, string, companyId, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const UserSelection = compose(withConnect, withRouter, injectIntl)(UserSelectionComp);
